import{a as n}from"./chunk-RAAYCPUM.js";function p(...e){return n(t,e)}var t=(e,o)=>e[o];export{p as a};
